import commentsSystemApi from '../api/commentsSystemApi';
import { IApiResponse } from '../interfaces/IApiResponse';
import eventDetail from '../models/eventDetail';

interface CommentReply {
  items: any[]; // Define a more specific type if possible
}

interface CommentLike {
  items: any[]; // Define a more specific type if possible
}

class CommentSystemServices {
  getReply(params: any): Promise<IApiResponse<any>> {
    return commentsSystemApi
      .getCommentReplies(params)
      .then((res: IApiResponse<CommentReply>) => {
        if (res.success) {
          if (res.data) {
            return {
              success: res.success,
              data: eventDetail.mappingObjectsEventComment(res.data.items),
            };
          }
          return { success: res.success, data: [] };
        }
        console.log('ERROR: commentSystemServices/getReply:', res);
        return { success: res.success, data: [] };
      })
      .catch((e: Error) => {
        console.warn('ERROR: commentSystemServices/getReply:', e);
        throw new Error('failed');
      });
  }

  getReplyFull(params: any): Promise<IApiResponse<any>> {
    return commentsSystemApi
      .getCommentRepliesFull(params)
      .then((res: IApiResponse<CommentReply>) => {
        if (res.success) {
          if (res.data) {
            return {
              success: res.success,
              data: eventDetail.mappingObjectsEventComment(res.data.items),
            };
          }
          return { success: res.success, data: {} };
        }
        console.log('ERROR: commentSystemServices/getReplyFull:', res);
        return { success: res.success, data: {} };
      })
      .catch((e: Error) => {
        console.warn('ERROR: commentSystemServices/getReplyFull:', e);
        throw new Error('failed');
      });
  }

  postCreateCommentLike(params: any): Promise<IApiResponse<any>> {
    return commentsSystemApi.postCreateCommentLike(params).then((res: IApiResponse<any>) => {
      try {
        return {
          success: res.success,
          data: res.data,
          message: res.message,
        };
      } catch (e) {
        console.log('ERROR: commentSystemServices/postCreateCommentLike:', res);
      }
      return { success: false };
    });
  }

  deleteCommentLike(params: any): Promise<IApiResponse<any>> {
    return commentsSystemApi.deleteCommentLike(params).then((res: IApiResponse<any>) => {
      try {
        return {
          success: res.success,
          data: res.data,
          message: res.message,
        };
      } catch (e) {
        console.log('ERROR: commentSystemServices/deleteCommentLike:', res);
      }
      return { success: false };
    });
  }

  deleteComment(commentId: number): Promise<IApiResponse<null>> {
    return commentsSystemApi
      .deleteComment(commentId)
      .then((res: IApiResponse<null>) => {
        if (res.success) {
          return { success: true };
        }
        return { success: false };
      })
      .catch((e: Error) => {
        console.warn('ERROR: commentSystemServices/deleteComment:', e);
        return { success: false, message: 'Cannot delete comment' };
      });
  }

  getCommentLikes(commentId: string, page: number): Promise<IApiResponse<any>> {
    return commentsSystemApi
      .getCommentLikes(commentId, page)
      .then((res: IApiResponse<CommentLike>) => {
        if (res.success) {
          return {
            success: true,
            data: eventDetail.mappingObjectsEventInterest(res?.data?.items || []),
          };
        }
        return { success: false };
      })
      .catch((e: Error) => {
        console.warn('ERROR: commentSystemServices/getCommentLikes:', e);
        return { success: false, message: 'Cannot getCommentLikes' };
      });
  }
}

export default new CommentSystemServices();
